module.exports = __webpack_public_path__ + "img/banner-en20x40.8dc1158b.jpg";